import React from 'react';
import PropTypes from 'prop-types';
import { getMessage } from 'util/locale';
import classNames from 'classnames';
import { Button } from '@tcc/crate';

const baseString = 'vra-script-flow-step-footer';
const classString = classNames({
  [`${baseString}__nav__button`]: true,
  [`${baseString}__nav__button--back`]: true
});
const ScriptFlowPreviousNavButton = ({
  canGoBack,
  onClickBack
}) => (
  <Button
    className={classString}
    disabled={!canGoBack}
    mode='secondary'
    onClick={onClickBack}
    testId={`${baseString}__button--back`}>
    {getMessage('button-text__previous')}
  </Button>
);
ScriptFlowPreviousNavButton.propTypes = {
  canGoBack: PropTypes.bool.isRequired,
  onClickBack: PropTypes.func.isRequired
};
export default ScriptFlowPreviousNavButton;
